import React from 'react';
import { useThemeMode, withTheme } from '@rneui/themed';
import RenderHtml from './RenderHtml';
import { Text as SkeletonText } from '../skeleton';
import { useWindowWidth } from '../../hooks/utils';
import { View } from '../elements';
import { DescriptionMask } from './DescriptionMask';
export const UnmemoizedDescription = ({ text = '', isLoading = false, containerStyle, maxHeight, color, showExpandButton = true }) => {
    const width = useWindowWidth();
    let Component = (React.createElement(SkeletonText, { lines: 8, size: "xsmall" }));
    if (!isLoading) {
        Component = (React.createElement(RenderHtml, { html: text, contentWidth: width, color: color }));
    }
    if (maxHeight === undefined) {
        return (React.createElement(View, { style: containerStyle }, Component));
    }
    else {
        return (React.createElement(DescriptionMask, { maxHeight: maxHeight, showExpandButton: showExpandButton, containerStyle: containerStyle }, Component));
    }
};
export const MemoizedDescription = React.memo(UnmemoizedDescription, (prev, next) => {
    const isTextIdentical = prev?.text === next?.text;
    const isIsLoadingIdentical = prev?.isLoading === next?.isLoading;
    const isThemeIdentical = prev?.mode === next?.mode;
    const isMaxHeightIdentical = prev?.maxHeight === next?.maxHeight;
    return (isTextIdentical &&
        isIsLoadingIdentical &&
        isThemeIdentical &&
        isMaxHeightIdentical);
});
export const ThemeAwareMemoizedDescription = (props) => {
    const { mode } = useThemeMode();
    return React.createElement(MemoizedDescription, { mode: mode, ...props });
};
export const Description = withTheme(ThemeAwareMemoizedDescription, 'Description');
//# sourceMappingURL=Description.js.map